module.exports = __webpack_public_path__ + "static/media/struts-struts.e72d130a.svg";